import React, {Component} from 'react'
import HttpRequest from "../../../HttpRequest";
import {Tools} from "../../../Tools";
import Loader from "../../../components/Loader";
import ErrorPage from "../../../components/ErrorPage";
import Route from "../../../Route";
import AuthenticationAPI from "../../../services/AuthenticationAPI";




class Contributions extends React.Component{
    static Views = {
        paid_contribution : {
            id: "paid-contribution",
            route: Route.APIMembersContributionsPaid,
            method: ""
        },
        not_paid_contribution : {
            id: "not-paid-contribution",
            route: Route.APIMembersContributionsNotPaid,
            method: ""
        },
        open_contribution : {
            id: "open-contribution",
            route: Route.APIPaymentsContributions,
            method: ""
        },
        futures_contribution : {
            id: "futures-contribution",
            route: Route.APIPaymentsContributionsFutures,
            method: ""
        },
        create_contribution : {
            id: "create-contribution",
            route: Route.APIPaymentsContributionsFutures,
            method: ""
        },
        save_contribution : {
            id: "save-contribution",
            route: Route.APIPaymentsContributionsFutures,
            method: ""
        },
        all_contribution : {
            id: "all-contribution",
            route: Route.APIPaymentsContributionsFutures,
            method: ""
        },
    };
    constructor(props) {
        super(props);

        this.httpClient = new HttpRequest();
        this.state = {
            server: {},
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            contributions: []
        };
        this.momoPayModalInfoRef = React.createRef();

        this.buildRoute();
        this.handlerEkoloPayInfo = this.handlerEkoloPayInfo.bind(this);
        this.handlerLaunchMail = this.handlerLaunchMail.bind(this);
        this.handlerPurchaseEkoloPay = this.handlerPurchaseEkoloPay.bind(this);
    }

    getContributionAttribute(event){
        let contribution = event.target.getAttribute("data-contribution");
        return contribution ? Tools.StringToJson(contribution) : {};
    }

    handlerEkoloPayInfo(event){
        const currentModal = this.momoPayModalInfoRef.current;
        const contribution = this.getContributionAttribute(event);
        if(currentModal){
            const purchaseEkoloPayBtn = currentModal.querySelector("#purchaseEkoloPayBtn");
            purchaseEkoloPayBtn.setAttribute("data-contribution", Tools.JsonToString(contribution));

            let
                product_details = currentModal.querySelector("#product-details"),
                alert_message = currentModal.querySelector("#alert-message")
            ;

            alert_message.innerHTML = "";
            alert_message.classList.add("hidden");
            product_details.innerHTML = contribution.product.details;
        }
    }

    handlerLaunchMail(event){
        const
            _self = this,
            contribution = this.getContributionAttribute(event),
            launchMailBtn = event.target,
            oldText = launchMailBtn.innerHTML,
            span = document.querySelector("#launch-mail-message-" + contribution.id)
        ;

        span.innerHTML = "";
        launchMailBtn.setAttribute("disabled", "disabled");
        launchMailBtn.innerHTML = "Patientez, envoie de mail en cours...";

        this.httpClient.request(Route.APIPaymentsContributionsRelaunchMail.replace("{id}", contribution.id), "PATCH", {}).then(function (response){
            _self.server = response;
            launchMailBtn.removeAttribute("disabled");
            launchMailBtn.innerHTML = oldText;
            span.innerHTML = response.message;
        }).catch(function (error){
            _self.server = error;
            launchMailBtn.removeAttribute("disabled");
            launchMailBtn.innerHTML = oldText;
            span.innerHTML = "Une erreur s'est produite, veuillez réessayer ultérieurement !";
        });
    }
    
    handlerPurchaseEkoloPay(event){
        const
            _self = this,
            contribution = _self.getContributionAttribute(event),
            ERROR_MESSAGE = "Une erreur s'est produite, contactez l'administrateur !",
            currentModal = this.momoPayModalInfoRef.current
        ;

        let alert_message = null;
        if(currentModal){
            alert_message = currentModal.querySelector("#alert-message");
        }

        let paySessionRoute = Route.PaySession.link;

        if(contribution.paySession && contribution.paySession.purchaseToken && contribution.paySession.token){
            // redirect to route allow to check if on the token the pay is already paid
            window.location = paySessionRoute.replace(":token", contribution.paySession.token);
            return;
        }
        else if(AuthenticationAPI.getCurrentUser()){
            const
                purchaseEkoloPayBtn = event.target,
                oldText = purchaseEkoloPayBtn.innerHTML
            ;

            purchaseEkoloPayBtn.setAttribute("disabled", "disabled");
            purchaseEkoloPayBtn.innerHTML = "Patientez...";

            let route = Route.APIPaymentsLaunchMobileMoneyContribution.replace("{contributionId}", contribution.id);
            route = route.replace("{contributorId}", AuthenticationAPI.getCurrentUser().accessToken);

            // On récupère le token
            this.httpClient.request(route, "PATCH", {}).then(function (response){
                if(response.code === 200 && response.data && response.data.token){
                    // redirect to route allow to check if on the token the pay is already paid
                    window.location = paySessionRoute.replace(":token", response.data.token);
                    return;
                }
                purchaseEkoloPayBtn.removeAttribute("disabled");
                purchaseEkoloPayBtn.innerHTML = oldText;

                const error_message = response.message ? response.message : ERROR_MESSAGE;
                if(alert_message){
                    alert_message.classList.remove("hidden");
                    alert_message.innerHTML = error_message;
                }
                else{
                    alert(error_message);
                }
            }).catch(function (error){
                purchaseEkoloPayBtn.removeAttribute("disabled");
                purchaseEkoloPayBtn.innerHTML = oldText;

                const error_message = error && error.message ? error.message : ERROR_MESSAGE;
                if(alert_message){
                    alert_message.classList.remove("hidden");
                    alert_message.innerHTML = error_message;
                }
                else{
                    alert(error_message);
                }
            });
        }
        else if(alert_message){
            alert_message.classList.remove("hidden");
            alert_message.innerHTML = ERROR_MESSAGE;
        }
        else{
            alert(ERROR_MESSAGE);
        }
    }

    render(){
        const _self = this;
        let element = <h3 className="">Aucune données !</h3>;
        if(!this.state.isLoadCompleted){
            element = <Loader />;
        }
        else if(this.state.hasError){
            const text = this.state.server && this.state.server.message ? "<h1>"+ this.state.server.message +"</h1>" : "";
            element = <ErrorPage data={{content: text}} />;
        }
        else if(!Tools.IsEmpty(this.state.contributions)){
            element = this.state.contributions.map((contribution, index) => {
                let section2 = "";
                switch (_self.props.view.id) {
                    case Contributions.Views.open_contribution.id:
                        section2 = <>
                            <div className="col-md-3 align-center">
                                <div className="row mb-4">
                                    <h4>Nombre de participant</h4>
                                    <div className="col-md-12">
                                        {contribution.contributorCount ? contribution.contributorCount : 0}
                                    </div>
                                </div>
                                <div className="row">
                                    <h4>Montant collecté</h4>
                                    <div className="col-md-12">
                                        {contribution.amountCollected ? contribution.amountCollected : 0}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-1">
                                {contribution.pending ? <div className="card card-legend-green"></div> : <div className="card card-legend-red"></div>}
                            </div>
                        </>
                        break;
                    case Contributions.Views.paid_contribution.id:
                        if(contribution.paySession){
                            const label = contribution.paySession.paymentMode && contribution.paySession.paymentMode ? contribution.paySession.paymentMode.label : "..."
                            section2 = <>
                                <div className="col-md-4 align-center">
                                    <h4>Mode de paiement</h4>{label}
                                    <h4 className="mt-3">Montant versé</h4>{contribution.paySession.amount}
                                </div>
                            </>
                        }
                        break;
                    case Contributions.Views.not_paid_contribution.id:
                        section2 = <>
                            <div className="col-md-4 align-center">
                                {contribution.debt ? <><h4>(Dette)</h4>Date de paiement dépassée</> : <h4>(Paiement en attente)</h4>}
                                <button  data-toggle="modal" data-target="#momoPayModalInfo" type="button" className="btn btn-outer-tab mt-3" data-contribution={Tools.JsonToString(contribution)} onClick={_self.handlerEkoloPayInfo}>
                                    Payer {contribution.debt ? "la dette"  : ""} en ligne par MoMo
                                </button>
                            </div>
                        </>
                        break;
                }

                let complete_desc = "";
                if(contribution.aContributionType.id === "monthly_statutory_fee"){
                    complete_desc = <div>Mois pris en compte : <strong>{Tools.MonthByIndex(contribution.month)} {contribution.year}</strong></div>
                }
                if(contribution.aContributionType.id === "annual_statutory_fee"){
                    complete_desc = <div>Année prise en compte : <strong>{contribution.year}</strong></div>
                }
                if(Contributions.Views.not_paid_contribution.id === _self.props.view.id || Contributions.Views.futures_contribution.id === _self.props.view.id){
                    complete_desc = <>
                        {complete_desc}
                        <div>Frais à prendre en charge pour le paiement en ligne : <strong>{contribution.cost} FCFA</strong></div>
                    </>
                }

                if(contribution.beneficiary && contribution.beneficiary.name){
                    complete_desc = <>
                        {complete_desc}
                        <div>Bénéficiaire : <strong>{contribution.beneficiary.name.toUpperCase() + " " + contribution.beneficiary.firstName}</strong></div>
                    </>
                }

                if(AuthenticationAPI.isAccountingManagerUser() || AuthenticationAPI.isPresidentUser()){
                    complete_desc = <>
                        {complete_desc}
                        <button key={"button-launch-mail-" + contribution.id} type="button" className="btn btn-outer-tab mt-6" data-contribution={Tools.JsonToString(contribution)} onClick={_self.handlerLaunchMail}>
                            Cliquer pour relancer par mail les membres n'ayant pas encore payés
                        </button>
                        <br/>
                        <span key={"span-launch-mail-" + contribution.id} id={"launch-mail-message-" + contribution.id} className="badge badge-success align-center"></span>
                    </>
                }

                return <div key={"contribution-" + contribution.id} className="row mb-4  card-body">
                    <div className="card">
                        <div className="col-md-8 paragraph">
                            <h5 className="">{contribution.title}</h5>
                            <div>Type : <strong>{contribution.aContributionType.label}</strong></div>
                            <div>Montant : <strong>{contribution.aContributionType.amount}</strong></div>
                            <div>Ouverture de paiement : <strong>{contribution.startedAt}</strong></div>
                            <div>Date limite de paiement : <strong>{contribution.closedAt}</strong></div>
                            {complete_desc}
                        </div>
                        {section2}
                    </div>
                </div>;
            });

            element = <>
                {
                    Contributions.Views.open_contribution.id === _self.props.view.id ?
                        <div className="row">
                            <div className="col-md-4"></div>
                            <div className="col-md-8">
                                <h5>Légende sur les contributions</h5>
                                <div className="row">
                                    <div className="col-md-4"><strong>(En cours)</strong><div className="card card-legend-green"></div></div>
                                    <div className="col-md-4"><strong>(Terminé)</strong><div className="card card-legend-red"></div></div>
                                </div>
                            </div>
                        </div>
                        : ""
                }
                <br/>
                <h3 className="">{this.state.server.message}</h3>
                {element}
                {
                    Contributions.Views.not_paid_contribution.id === _self.props.view.id ?
                        <div id="momoPayModalInfo" ref={_self.momoPayModalInfoRef} className="modal" tabIndex="-1" role="dialog">
                            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Information pour payer en ligne par MoMo</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div id="alert-message" className="alert alert-danger hidden"></div>
                                        <div id="product-details"></div>
                                        <p>Cliquez sur le bouton <strong>Je paie</strong> pour passer au paiement.</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button id="purchaseEkoloPayBtn" type="button" className="btn btn-primary" onClick={this.handlerPurchaseEkoloPay}>Je paie</button>
                                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Annuler</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        ""
                }
                </>
            ;
        }

        return element;
    }

    buildRoute(){
        this.currentRoute = this.props.view.route;
        if(this.currentRoute.includes("memberId") && AuthenticationAPI.getCurrentUser()){
            this.currentRoute = this.currentRoute.replace("{memberId}", AuthenticationAPI.getCurrentUser().accessToken);
        }
    }
    componentDidMount() {
        this.loadContributions();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.view.id !== prevProps.view.id){
            this.setState({contributions: [], isLoadCompleted: false});
            this.buildRoute();
            this.loadContributions();
        }
    }

    loadContributions(){
        const _self = this;
        this.httpClient.request(this.currentRoute, "GET", {}).then(function (response){
            _self.server = response;
            _self.setState({server: response, isLoadCompleted: true, hasError: response.code === 0, ...response.data});
        }).catch(function (error){
            _self.server = error;
            _self.setState({server: error, hasError: true });
        });
    }
}

export default Contributions;